module.exports = __webpack_public_path__ + "static/media/sportsdirect.fb465171.png";